const LoadState = require("./util/LoadState");
const _ = require("lodash");
const OpsUser = require("./OpsUser");
const {atTutorial, atUser} = require("./StateCursors");
const {FLAGS} = require("../util/GlobalFlags");

const init = function() {
	const base = {
		currentPart: "beginStudentTutorial",
		currentStep: "welcomeToBA",
		currentProblemIndex: 0,
		showEgbertaModal: false,
		timesModalOpened: 0,
		totalTimesModalOpened: {
			lesson: 0,
			homePage: 0,
		},
		showGetStartedOrangeArrow: false,
		hideTutorialModal: false,
		video: LoadState.loadInit({}),
		book: LoadState.loadInit({}),
		problemsWorkedOn: [],
		partsVisited: [],
		nextStepOpts: {},
	};
	return LoadState.loadInit(base);
};

const updateTutorialData = function(state) {
	const user = atUser(state).get();
	const progress = getUserProgress(user);
	const tutorial = atTutorial(state).get();
	return {
		currentPart: progress.part,
		currentStep: progress.step,
		currentProblemIndex: tutorial.currentProblemIndex,
		hideTutorialModal: false,
		showEgbertaModal: false,
		timesModalOpened: tutorial.timesModalOpened,
		totalTimesModalOpened: tutorial.totalTimesModalOpened,
		showGetStartedOrangeArrow: false,
		video: tutorial.video,
		book: tutorial.book,
		problemsWorkedOn: tutorial.problemsWorkedOn,
		partsVisited: tutorial.partsVisited,
		nextStepOpts: {},
	};
};

const isDoingResult = function(partName) {
	return partName.startsWith("doLessonProblem");
};

const shouldUpdateProgress = function(
	parts,
	prevPartName,
	newPartName,
	tutorial
) {
	const oldPartIndex = _.indexOf(parts, prevPartName);
	const newPartIndex = _.indexOf(parts, newPartName);

	// We only want to update progress (ie save their new progress in the db) if
	// this is a problem they HAVEN'T done yet (ie when they get to problem 3 from problem 2)
	// but we DON'T want to save it if they visit a previous problem, otherwise
	// they would resume the lesson on the wrong problem and have to
	// click through a number of problems to get to where they left off
	// and could also have the incorrect messages appearing briefly
	if (isDoingResult(newPartName)) {
		const lastChar = _.toInteger(newPartName[newPartName.length - 1]);
		if (lastChar > 0) {
			const idx = lastChar - 1;
			const problemsWorkedOn = _.get(tutorial, "problemsWorkedOn", []);
			if (_.includes(problemsWorkedOn, idx)) {
				return false;
			}
		}
	}
	return newPartIndex > oldPartIndex;
};

const getUserProgress = function(user) {
	const eventsTriggered = _.get(user, "model.eventsTriggered", {});
	const studentTutorial = _.get(
		eventsTriggered,
		"tutorials.studentTutorial",
		{}
	);
	const userCurrentPart = _.get(studentTutorial, "currentPart", "finished");
	const userCurrentStep = _.get(studentTutorial, "currentStep", "finished");
	return {
		part: userCurrentPart,
		step: userCurrentStep,
	};
};

const shouldSeeTutorial = function(user) {
	const hasTrainerPermission = OpsUser.hasTrainerPermission(user);
	const isTeacher = OpsUser.hasTeacherRole(user);
	const shouldSee =
		FLAGS.studentTutorialEnabled && hasTrainerPermission && !isTeacher;
	return shouldSee;
};

const isTutorialActive = function(user) {
	const userProgress = getUserProgress(user);
	const isTeacher = OpsUser.hasTeacherRole(user);
	const isEnabled =
		FLAGS.studentTutorialEnabled &&
		userProgress.part !== "finished" &&
		!isTeacher;
	return isEnabled;
};

const isTutorialFinished = function(tutorial) {
	return _.get(tutorial, "currentPart", null) === "finished";
};

const isTutorialEnabled = function() {
	return FLAGS.studentTutorialEnabled;
};

module.exports = {
	init,
	updateTutorialData,
	isDoingResult,
	shouldUpdateProgress,
	getUserProgress,
	shouldSeeTutorial,
	isTutorialActive,
	isTutorialFinished,
	isTutorialEnabled,
};
